import { render } from 'react-dom'
import { TileGrid, Tile, TileSpacer } from '../../layout/tile-grid/tile-grid'

import CSS from './page-header.module.css'

export function PageHeader ({ children, theme }) {

    
    const radomImage = () => {
        
        const squareTilesArray = [ '01', '02', '11', '13', '05', '07', '09', '10', '12', '04', '03', '14' ]
        const selectedTiles = []

        let text = " ";
        for (let i = 0; i < 4; i++) {
            let index = Math.floor(Math.random() * squareTilesArray.length);
            let tile = squareTilesArray[index];
            squareTilesArray.splice(index, 1);
            selectedTiles.push(tile)

        }
        // console.log('randomTiles:', selectedTiles)

        return selectedTiles
    }


    return (
        <section className={`${CSS.container} ${ theme ? theme : `bg-primary`}`} >

            <div className={CSS.layout}>
                <div className={CSS.heroGraphic}>
                    
                    <TileGrid>
                        { radomImage().map((tile, index) => <Tile key={tile} src={`/assets/theme/2023/aviadev-RE-2023-tile-${tile}.png`} />) }
                    </TileGrid>

                </div>

                <section className={`${CSS.content} block formatted`}>
                    { children }
                </section>
            </div>

            <div className={`${CSS.offset} ${ theme ? theme : `bg-primary`}`} ></div>

        </section>


    )
}